var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBook = function SvgBook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M20.99 2.25A9.435 9.435 0 0 0 11 2.1a9.435 9.435 0 0 0-9.99.15 1.14 1.14 0 0 0-.51.952v11.423a1.852 1.852 0 0 0 .825 1.545 1.913 1.913 0 0 0 1.785.172 8.002 8.002 0 0 1 7.5.75.75.75 0 0 0 .84 0 8.002 8.002 0 0 1 7.5-.75 1.89 1.89 0 0 0 2.392-.84c.144-.27.219-.571.218-.877V3.202a1.117 1.117 0 0 0-.57-.952ZM2.54 14.947a.427.427 0 0 1-.382 0 .353.353 0 0 1-.158-.3V3.398a7.92 7.92 0 0 1 8.25 0v11.79a9.434 9.434 0 0 0-7.71-.247v.008ZM20 14.626a.352.352 0 0 1-.157.3.428.428 0 0 1-.383 0 9.547 9.547 0 0 0-7.71.255V3.412a7.92 7.92 0 0 1 8.25 0v11.213Z"
  })));
};
export default SvgBook;